let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fXKsE")).then(() => parcelRequire('llFf1'));